export default "__VITE_ASSET__01181049__"